<form [formGroup]="ondernemingFg">
    <snelstart-ui-select-form-control (change)="saveForm()"
                                      [options]="this.optionsJaNee"
                                      [required]=true
                                      class="me-1 custom-input-250"
                                      formControlName="verzoekToepassenBorInSw"
                                      id="verzoekToepassenBorInSw"
                                      label="Verzoek toepassen BOR door ontvanger"
    >
    </snelstart-ui-select-form-control>
    <div *ngIf="this.ondernemingFg.get('verzoekToepassenBorInSw')?.value">
        <snelstart-ui-select-form-control (change)="saveForm()"
                                          [options]="this.optionsJaNee"
                                          [required]=true
                                          class="me-1 custom-input-250"
                                          formControlName="voorOverlegHeeftPlaatsgevonden"
                                          id="voorOverlegHeeftPlaatsgevonden"
                                          label="Voorloverleg inspecteur"
        >
        </snelstart-ui-select-form-control>


        <snelstart-ui-number-form-control (change)="saveForm()"
                                          [showAllDecimals]="false"
                                          align="right"
                                          class="me-1 custom-input-250"
                                          formControlName="waardeBeleggingsVermogen"
                                          id="waardeBeleggingsVermogen"
                                          label="Waarde beleggingsvernogen"
                                          prefix="€"
        >
        </snelstart-ui-number-form-control>


        <snelstart-ui-number-form-control (change)="saveForm()"
                                          [showAllDecimals]="false"
                                          align="right"
                                          class="me-1 custom-input-250 custom-readonly"
                                          formControlName="waardeOndernemingsVermogen"
                                          id="waardeOndernemingsVermogen"
                                          label="Waarde ondernemingsvermogen"
                                          prefix="€"
        >
        </snelstart-ui-number-form-control>

        <div formGroupName="opvolger" class="pt-2">
            <div *ngIf="this.heeftBelastOndernemingsvermogen">

                <snelstart-ui-select-form-control (change)="saveForm()"
                                                  [options]="this.optionsJaNee"
                                                  [required]=true
                                                  class="me-1 custom-input-250"
                                                  formControlName="verzoekConserverendeAanslag"
                                                  id="verzoekConserverendeAanslag"
                                                  label="Verzoek conserverende aanslag"
                >
                </snelstart-ui-select-form-control>
            </div>
        </div>
    </div>

</form>

